module.exports = __webpack_public_path__ + "static/media/10284.5737bad5.jpg";